'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.clearSettingFilter = void 0;
var tslib_1 = require("tslib");
var BROWSER_FILTERS = ['request-id', 'instance-id'];
function clearSettingFilter(setting) {
    var e_1, _a;
    var filter = {};
    try {
        for (var BROWSER_FILTERS_1 = tslib_1.__values(BROWSER_FILTERS), BROWSER_FILTERS_1_1 = BROWSER_FILTERS_1.next(); !BROWSER_FILTERS_1_1.done; BROWSER_FILTERS_1_1 = BROWSER_FILTERS_1.next()) {
            var key = BROWSER_FILTERS_1_1.value;
            if (setting.filter.hasOwnProperty(key)) {
                filter[key] = setting.filter[key];
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (BROWSER_FILTERS_1_1 && !BROWSER_FILTERS_1_1.done && (_a = BROWSER_FILTERS_1.return)) _a.call(BROWSER_FILTERS_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return {
        key: setting.key,
        value: setting.value,
        priority: setting.priority,
        filter: filter,
    };
}
exports.clearSettingFilter = clearSettingFilter;
//# sourceMappingURL=clearSettingFilter.js.map
